import {
    Box,
    Container,
    Flex,
    Image,
    Link,
    List,
    Stack,
    Text,
    useBreakpointValue,
} from "@chakra-ui/react";
import { WhatsappLogoIcon } from "@phosphor-icons/react/dist/ssr";
import Head from "next/head";

import { HUBSPOT_KEY } from "@/config/config";
import Footer from "@/sections/home/Footer";
import Header from "@/sections/home/Header";
import Banner from "@/sections/referidos/Banner";
import Contact from "@/sections/referidos/Contact";
import Develops from "@/sections/referidos/Develops";

export async function getServerSideProps() {
    const idForm = "337b3e74-9b7b-4fb2-976a-4c6f914fb510";
    const url = `https://api.hubapi.com/forms/v2/fields/${idForm}`;

    try {
        const response = await fetch(url, {
            method: "GET",
            headers: {
                Authorization: `Bearer ${HUBSPOT_KEY}`,
            },
        });
        const data = await response.json();
        return {
            props: {
                optionsDevelops: data,
            },
        };
    } catch (error) {
        console.error("Error: ", error);
        return {
            props: {
                optionsDevelops: "",
            },
        };
    }
}

export default function Referidos({ optionsDevelops }) {
    const isGreaterThanMd = useBreakpointValue({ base: false, md: true });

    return (
        <>
            <Header />
            <Head>
                <title>Referidos | Grupo Guía</title>
                <link rel="canonical" href="https://grupoguia.mx/referidos" />
                <link rel="alternate" href="https://grupoguia.mx/referidos" hrefLang="es-mx" />
            </Head>
            <Container maxW="full" {...(!isGreaterThanMd && { paddingInline: "0" })}>
                <Box
                    style={{ marginBottom: "4rem" }}
                    {...(!isGreaterThanMd && { full: "full" })}
                    mb="28"
                >
                    <Banner optionsDevelops={optionsDevelops[7].options} />
                </Box>
                <Box>
                    <Text fontSize="2xl" textAlign="center" margin="0" fontWeight="extrabold">
                        ¿Cómo funciona?
                    </Text>
                    <Stack my={6}>
                        <Flex direction={{ base: "column", md: "row" }}>
                            <Stack w={{ base: "100%", md: "50%" }}>
                                <Flex
                                    p={10}
                                    bg="#EBEBEB"
                                    gap={4}
                                    pl={{ base: 10, md: 20 }}
                                    alignItems="center"
                                >
                                    <Image
                                        src="https://media.grupoguia.mx/assets/guiaconnect/icon/icon_refiere.svg"
                                        maxW={20}
                                        maxH={20}
                                        alt="simple icon"
                                    />
                                    <Stack>
                                        <Text fontSize="xl" fontWeight="bold">
                                            Refiere
                                        </Text>
                                        <Text fontSize="lg" fontWeight="normal">
                                            De manera muy fácil y segura, completa los datos de tu
                                            cliente y enseguida tu asesor se pondrá en contacto con
                                            él.
                                        </Text>
                                    </Stack>
                                </Flex>
                            </Stack>
                            <Stack w={{ base: "100%", md: "50%" }}>
                                <Flex
                                    p={10}
                                    bg="#F4F4F4"
                                    gap={4}
                                    pr={{ base: 10, md: 20 }}
                                    alignItems="center"
                                >
                                    <Image
                                        src="https://media.grupoguia.mx/assets/guiaconnect/icon/icon_gana.svg"
                                        maxW={20}
                                        maxH={20}
                                        alt="simple icon"
                                    />
                                    <Stack>
                                        <Text fontSize="xl" fontWeight="bold">
                                            Y gana
                                        </Text>
                                        <Text fontSize="lg" fontWeight="normal">
                                            Recibe bonos a través de una tarjeta que podrás utilizar
                                            para pagos de servicios, compras, retiros en efectivo...
                                            ¡Y más!
                                        </Text>
                                    </Stack>
                                </Flex>
                            </Stack>
                        </Flex>
                    </Stack>
                </Box>
                <Flex direction="column" w="100%" left="0" right="0" textAlign="center">
                    <Text fontSize="2xl">
                        <strong>Bonos Guia Connect</strong>
                    </Text>
                </Flex>
                <Box my={5}>
                    <Develops />
                </Box>
                <Box my="28" maxW={{ base: "100vw", md: "8xl" }} mx="auto" placeItems="center">
                    <Flex
                        justifyContent="center"
                        direction={{ base: "column", md: "row" }}
                        px={{ base: 10, md: 0 }}
                    >
                        <Stack align={{ base: "center", md: "initial" }}>
                            <Image
                                src="https://media.grupoguia.mx/assets/guiaconnect/logo/logo_guiaconnect_2.svg"
                                w="250px"
                                alt="simple icon"
                            />
                            <Text fontSize="xl" fontWeight="600" pt={6}>
                                Ahora te ofrece más
                            </Text>
                            <Text
                                fontSize="2xl"
                                fontWeight="800"
                                textAlign={{ base: "center", md: "initial" }}
                            >
                                beneficios con tu tarjeta Broxel
                            </Text>
                            <List.Root gap={3} pt={6}>
                                <List.Item>
                                    <Text fontSize="lg" fontWeight="normal">
                                        Libertad de compras
                                    </Text>
                                </List.Item>
                                <List.Item>
                                    <Text fontSize="lg" fontWeight="normal">
                                        Manejo de tarjetas con CHIP + NIP
                                    </Text>
                                </List.Item>
                                <List.Item>
                                    <Text fontSize="lg" fontWeight="normal">
                                        Paga tus servicios
                                    </Text>
                                </List.Item>
                                <List.Item>
                                    <Text fontSize="lg" fontWeight="normal">
                                        Retiros en ATM
                                    </Text>
                                </List.Item>
                                <List.Item>
                                    <Text fontSize="lg" fontWeight="normal">
                                        Aceptación nacional e internacional
                                    </Text>
                                </List.Item>
                            </List.Root>
                        </Stack>
                        <Stack>
                            <Image
                                src="https://media.grupoguia.mx/assets/guiaconnect/image/broxel.png"
                                maxW={{ base: "90vw", md: "500px" }}
                                alt="simple icon"
                            />
                        </Stack>
                    </Flex>
                </Box>
                <Box my="28" maxW="8xl" mx="auto" placeItems="center" textAlign="-webkit-center">
                    <Contact optionsDevelops={optionsDevelops[7].options} />
                </Box>
                <Link
                    href="https://api.whatsapp.com/send?phone=3321010557&amp;text=Hola quisiera información."
                    position="fixed"
                    w="16"
                    h="16"
                    right="8"
                    bottom="8"
                    rounded="full"
                    textAlign="center"
                    shadow="md"
                    target="_blank"
                    rel="noopener noreferrer"
                    display="flex"
                    alignItems="center"
                    justifyContent="center"
                    external
                    bg="green.400"
                    color="white"
                    fontSize="2xl"
                    _hover={{ shadow: "xl", textDecoration: "none" }}
                    transitionDuration=".6s"
                    zIndex="999"
                >
                    <WhatsappLogoIcon size={50} />
                </Link>
            </Container>
            <Footer esGuiaRent={false} esGuiaConnect={true} />
        </>
    );
}
